import { useEffect } from "react";
import DashboardWidget from "../widgets/dashboard";

export const DashboardPage = () => {
  useEffect(() => {
    document.title = "Avtamata";
  }, []);
  return <DashboardWidget />;
};
